import { AbstractControl } from '@angular/forms';
import { Field } from '../../objects/field';
import { StudioFormTab } from '../../services/form.service';
import { blank, filled, OptionalValue, spf } from './common'

const STUDIO_SUPPORTED_FIELDS = [
  'text',
  'address',
  'checkbox',
  'number',
  'currency',
  'dropdown',
  'multiselect',
  'textarea',
  'date',
  'datetime',
  'url',
];

export const is_studio_custom_field = (name: string, opts: {
  of_type?: string;
} = {}): boolean => {
  if (blank(name)) {
    return false;
  }

  let types: string[] = [];

  if (filled(opts.of_type)) {
    types = [opts.of_type];
  } else {
    types = STUDIO_SUPPORTED_FIELDS;
  }

  for (const typpe of types) {
    const format = new RegExp(spf('^(?:%s)[\\d]+$', {
      args: [typpe],
    }), 'i');

    if (format.test(name)) {
      return true;
    }
  }

  return false;
}

export const get_studio_fields_info = (tabs: StudioFormTab[], args: {
  field_names: string[];
}): StudioFieldInfo[] => {
  let fields: StudioFieldInfo[] = [];

  for (const tab of tabs) {
    for (const field of tab.fields) {
      if (args.field_names.includes(field.key)) {
        fields.push({
          field,
          form_control: tab.groups.controls[field.key],
        });
      }
    }
  }

  return fields;
}

type StudioFieldInfo = {
  field: Field;
  form_control: AbstractControl;
}